import React, { FC } from "react";
import { container_classname } from "./new-ui/constants";

interface ComparisonItem {
    usual: string;
    gallabox: string;
}

interface ComparisonRowProps {
    item: ComparisonItem;
    index: number;
    totalItems: number;
    type: "usual" | "gallabox";
}
type DesktopComparisonRowProps = Omit<ComparisonRowProps, "type">;

const usualBorderColor = "#CDCDCD";
const gallaboxBorderColor = "#B3C4FF";

const comparisonData: ComparisonItem[] = [
    {
        usual: "Expensive Price Tag",
        gallabox: "No added cost",
    },
    {
        usual: "Linear and predictable text flow",
        gallabox: "Dynamic, adaptable conversational flow",
    },
    {
        usual: "Limited capacity to understand the context",
        gallabox: "High conversational intelligence",
    },
    {
        usual: "Prone to outages and overloads",
        gallabox: "No pesky 'outage or over-limit' promise",
    },
    {
        usual: "Based on pre-set templates",
        gallabox: "Generate custom real-time responses",
    },
    {
        usual: "Little to no integration capabilities",
        gallabox: "Sync easily with third-party apps",
    },
];

const ComparisonRow: FC<ComparisonRowProps> = ({ item, index, totalItems, type }) => {
    const isLastItem = index === totalItems - 1;

    return (
        <>
            <div className="px-6 py-4 text-black" style={{ borderBottom: isLastItem ? "none" : `1px solid ${type === "usual" ? usualBorderColor : gallaboxBorderColor}` }}>
                {item[type]}
            </div>
        </>
    );
};

const DesktopComparisonRow: FC<DesktopComparisonRowProps> = ({ item, index, totalItems }) => {
    const isLastItem = index === totalItems - 1;

    return (
        <tr>
            <td className="px-6 py-4 text-black bg-gray-50 w-1/2 border-0" style={{ borderBottom: isLastItem ? "none" : `1px solid ${usualBorderColor}` }}>
                {item.usual}
            </td>
            <td className="px-6 py-4 text-black bg-indigo-50 w-1/2 border-0" style={{ borderBottom: isLastItem ? "none" : `1px solid ${gallaboxBorderColor}` }}>
                {item.gallabox}
            </td>
        </tr>
    );
};

const AiCompareComponent: FC = () => {
    const renderComparisonRows = (type: "usual" | "gallabox") => {
        return comparisonData.map((item, index) => <ComparisonRow key={`mobile-${index}`} item={item} index={index} totalItems={comparisonData.length} type={type} />);
    };

    const renderDesktopComparisonRows = () => {
        return comparisonData.map((item, index) => <DesktopComparisonRow key={`desktop-${index}`} item={item} index={index} totalItems={comparisonData.length} />);
    };

    return (
        <div className="px-4 lg:px-0 mx-auto max-w-5xl w-full" style={{ fontFamily: "Inter" }}>
            <h5 className={`${container_classname} text-6xl md:text-center font-degular`}>Why choose Gallabox AI bot?</h5>
            <div className="md:hidden relative w-full pt-10 max-w-6xl mx-auto">
                <div className="bg-white rounded-xl overflow-hidden">
                    <div className="flex flex-col">
                        <div className="bg-gray-400 text-white px-6 py-4 text-center font-semibold text-lg">Your Usual AI Tools</div>
                        <div className="bg-gray-50">{renderComparisonRows("usual")}</div>
                        <div className="bg-blue-color text-white px-6 py-4 text-center font-semibold text-lg">The Gallabox Approach</div>
                        <div className="bg-indigo-50">{renderComparisonRows("gallabox")}</div>
                    </div>
                </div>
            </div>
            <div className="hidden md:block relative w-full pt-10 max-w-6xl mx-auto">
                <div className="bg-white rounded-xl overflow-hidden">
                    <table className="w-full border-collapse">
                        <thead>
                            <tr>
                                <th className="bg-gray-400 text-white px-6 py-4 text-left font-semibold text-lg border-0">Your Usual AI Tools</th>
                                <th className="bg-blue-color text-white px-6 py-4 text-left font-semibold text-lg border-0">The Gallabox Approach</th>
                            </tr>
                        </thead>
                        <tbody>{renderDesktopComparisonRows()}</tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default AiCompareComponent;
